<template>
  <editor
    @cancel="cancel()"
    @password-changed="passwordChanged($event)"
  />
</template>
<script>
import editor from "vue-template/protected/editors/ChangePasswordEditor";

export default {
  components: {
    editor
  },

  props: {
    defaultRoute: {
      type: [String, Object],
      default: '/'
    }
  },

  mounted() {
    this.$emit('breadcrumbs', this.breadcrumbs());
  },

  methods: {
    breadcrumbs() {
      return [
        {
          icon: 'home',
          text: 'Home',
          to: '/protected'
        },
        {
          text: () => this.$t("menu.changePassword"),
        }
      ]
    },

    cancel() {
      this.$router.push(this.defaultRoute);
    },

    passwordChanged() {
      this.$router.push(this.defaultRoute);
    }
  }
};
</script>
